module.exports = __webpack_public_path__ + "static/img/logo-sovrn-bg-dark.570a1ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-sovrn-bg-dark.png
// module id = kVcJ
// module chunks = 1